import { ScaleIcon, UserGroupIcon, DocumentChartBarIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import logo from "../assets/logoNA.svg";
export default function TermsOfService() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-sky-500 to-white">
      <nav className="fixed w-full bg-white/90 backdrop-blur-lg shadow-lg z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20"> {/* Increased height */}
            <div className="flex-shrink-0 flex items-center space-x-3">
              <div className="relative w-16 h-16">
                <img src={logo} alt='' />
              </div>
              <a href='/' className="text-3xl p-0 m-0 font-bold bg-gradient-to-r from-blue-900 to-sky-600 bg-clip-text text-transparent no-underline leading-tight pb-1">
                NexusAgents
              </a>
            </div>

            {/* Desktop Menu - Increased text size */}
            <div className="hidden md:flex space-x-8">
              <a href="services" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Services</a>
              <a href="how" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">How It Works</a>
              <a href="contact" className="text-blue-900 no-underline hover:text-sky-600 text-xl font-semibold">Contact</a>
            </div>
            {/* <a href="login" className="hidden md:flex bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a>
                        <a href="login" className="md:hidden bg-sky-600 no-underline hover:bg-blue-900 text-white rounded-full px-4 py-2 text-xl font-semibold ">SignIn/Up</a> */}

            {/* Mobile Menu Button - Larger size */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-3 rounded-lg text-blue-900 hover:bg-sky-50"
            >
              <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu - Larger text */}
        {isMenuOpen && (
          <div className="md:hidden px-4 pt-2 pb-4 space-y-2">
            <a href="services" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Services</a>
            <a href="how" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">How It Works</a>
            <a href="contact" className="block px-4 py-3 text-lg text-blue-900 no-underline hover:bg-sky-50 rounded-xl">Contact</a>
          </div>
        )}
      </nav>

      <div className="py-32 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <ScaleIcon className="h-16 w-16 text-sky-300 mx-auto mb-4" />
          <h1 className="text-4xl font-bold text-white mb-2">Terms of Service</h1>
          <p className="text-sky-200 text-lg">Last Updated: [1st May 2025]</p>
        </div>

        <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-xl p-8 sm:p-12">
          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold text-blue-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-8 text-justify">
              By accessing or using NexusAgents services, you agree to be bound by these Terms.
              If you disagree with any part, you may not access our services. Please read this page carefully.

              The business agency, any of its business divisions and / or its subsidiaries, associate agencies or subsidiaries
              to subsidiaries or such other investment companies (in India or abroad) reserve their respective rights to
              revise these Terms and Conditions at any time by updating this posting. You should visit this page
              periodically to re-appraise yourself of the Terms and Conditions, because they are binding on all users
              of this Website.
            </p>

            <h2 className="text-2xl font-semibold text-blue-900 mb-4">2. Use of Content</h2>
            <p className="text-gray-700 mb-8 text-justify">
              All logos, brands, marks headings, labels, names, signatures, numerals, shapes or any combinations thereof,
              appearing in this site, except as otherwise noted, are properties either owned, or used under licence,
              by the business and / or its associate entities who feature on this Website. The use of these properties
              or any other content on this site, except as provided in these terms and conditions or in the site content,
              is strictly prohibited.You may not sell or modify the content of this Website or reproduce, display,
              publicly perform, distribute, or otherwise use the materials in any way for any public or
              commercial purpose without the respective organisation’s or entity’s written permission.
            </p>

            <h2 className="text-2xl font-semibold text-blue-900 mb-4">3. Security Rules</h2>
            <p className="text-gray-700 mb-8 text-justify">
              Visitors are prohibited from violating or attempting to violate the security of the Web site,
              including, without limitation, (1) accessing data not intended for such user or logging into a server
              or account which the user is not authorised to access, (2) attempting to probe, scan or test the
              vulnerability of a system or network or to breach security or authentication measures without proper
              authorisation, (3) attempting to interfere with service to any user, host or network, including,
              without limitation, via means of submitting a virus or "Trojan horse" to the Website, overloading,
              "flooding", "mail bombing" or "crashing", or (4) sending unsolicited electronic mail,
              including promotions and/or advertising of products or services. Violations of system or network
              security may result in civil or criminal liability. The business and / or its associate entities
              will have the right to investigate occurrences that they suspect as involving such violations and
              will have the right to involve, and cooperate with, law enforcement authorities in prosecuting users
              who are involved in such violations.
            </p>

            <h2 className="text-2xl font-semibold text-blue-900 mb-4">4. General Rules & Indemnity</h2>
            <p className="text-gray-700 mb-8 text-justify">
              Visitors may not use the Web Site in order to transmit, distribute, store or destroy material
              (a) that could constitute or encourage conduct that would be considered a criminal offence or
              violate any applicable law or regulation, (b) in a manner that will infringe the copyright,
              trademark, trade secret or other intellectual property rights of others or violate the privacy or
              publicity of other personal rights of others, or (c) that is libellous, defamatory, pornographic,
              profane, obscene, threatening, abusive or hateful.
              <br />
              The User unilaterally agree to indemnify and hold harmless, without objection, the Company,
              its officers, directors, employees and agents from and against any claims, actions and/or demands
              and/or liabilities and/or losses and/or damages whatsoever arising from or resulting from their use
              of NexusAgents Website or their breach of the terms .
            </p>

            <h2 className="text-2xl font-semibold text-blue-900 mb-4">5. Liability & Disclaimer</h2>
            <p className="text-gray-700 mb-8 text-justify">
              User agrees that neither Company nor its group companies, directors, officers or employee shall be
              liable for any direct or/and indirect or/and incidental or/and special or/and consequential or/and
              exemplary damages, resulting from the use or/and the inability to use the service or/and for cost of
              procurement of substitute goods or/and services or resulting from any goods or/and data or/and
              information or/and services purchased or/and obtained or/and messages received or/and transactions
              entered into through or/and from the service or/and resulting from unauthorized access to or/and
              alteration of user's transmissions or/and data or/and arising from any other matter relating to the
              service, including but not limited to, damages for loss of profits or/and use or/and data or other
              intangible, even if Company has been advised of the possibility of such damages.
              <br />
              User further agrees that Company shall not be liable for any damages arising from interruption,
              suspension or termination of service, including but not limited to direct or/and indirect or/and
              incidental or/and special consequential or/and exemplary damages, whether such interruption or/and
              suspension or/and termination was justified or not, negligent or intentional, inadvertent or advertent.
              <br />
              User agrees that Company shall not be responsible or liable to user, or anyone, for the statements
              or conduct of any third party of the service. In sum, in no event shall Company's total liability to
              the User for all damages or/and losses or/and causes of action exceed the amount paid by the User to
              Company, if any, that is related to the cause of action.
              <br />
              NexusAgents has stringent security measures in place to protect the loss, misuse, and alteration of the
              information under our control. Whenever you change or access your account information, we offer the use
              of a secure server. Once your information is in our possession we adhere to strict security guidelines,
              protecting it against unauthorized access.
            </p>

            {/* <h2 className="text-2xl font-semibold text-blue-900 mb-4">2. Service Scope</h2>
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div className="p-4 bg-sky-50 rounded-lg">
                <UserGroupIcon className="h-8 w-8 text-sky-600 mb-2" />
                <h3 className="font-semibold mb-2">Eligibility</h3>
                <p className="text-sm">Services available to users 18+ years old. Business clients must provide valid credentials.</p>
              </div>
              <div className="p-4 bg-sky-50 rounded-lg">
                <DocumentChartBarIcon className="h-8 w-8 text-sky-600 mb-2" />
                <h3 className="font-semibold mb-2">Service Limitations</h3>
                <p className="text-sm">We reserve right to refuse service for illegal items, hazardous materials, or unreasonable requests.</p>
              </div>
            </div> 

            <h2 className="text-2xl font-semibold text-blue-900 mb-4">3. Payments & Fees</h2>
            <ul className="list-disc pl-6 space-y-2 mb-8">
              <li>All prices in [Your Currency]</li>
              <li>Payment due before service completion</li>
              <li>15% cancellation fee if canceled 24hrs before service</li>
              <li>No refunds after service completion</li>
            </ul>

            <h2 className="text-2xl font-semibold text-blue-900 mb-4">4. User Responsibilities</h2>
            <div className="grid gap-4 md:grid-cols-2 mb-8">
              <div className="p-4 border border-sky-100 rounded-lg">
                <h3 className="font-semibold mb-2">Accurate Information</h3>
                <p className="text-sm">Provide correct addresses, contact details, and special instructions</p>
              </div>
              <div className="p-4 border border-sky-100 rounded-lg">
                <h3 className="font-semibold mb-2">Prohibited Actions</h3>
                <p className="text-sm">No misuse of agents, harassment, or illegal requests</p>
              </div>
            </div>

            <h2 className="text-2xl font-semibold text-blue-900 mb-4">5. Liability</h2>
            <p className="text-gray-700 mb-8">
              We carry [Insurance Amount] in general liability insurance. Maximum claim amount limited to service fee paid. 
              Not liable for delays due to weather, traffic, or unforeseen circumstances.
            </p>

            <h2 className="text-2xl font-semibold text-blue-900 mb-4">6. Modifications</h2>
            <p className="text-gray-700 mb-8">
              Terms may be updated periodically. Continued use after changes constitutes acceptance.
            </p> */}

            <div className="bg-sky-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-blue-900 mb-2">Contact for Disputes</h3>
              <p className="text-gray-700">
                Email: nexusagents123@gmail.com<br />
                Phone: +91 9696967088<br />
                {/* Arbitration conducted in [Your Jurisdiction] */}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 bg-gradient-to-r from-blue-900 to-sky-600">
        {/* <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">  </div> */}
        <div className="w-full grid md:grid-cols-3 gap-8 mx-auto my-5 text-center px-4 sm:px-6 lg:px-8">
          <div>
            <h2 className="text-3xl font-bold text-white mb-6 text-center">About NexusAgents</h2>
            <p className="text-sky-100 mb-8 text-xl text-justify">
              {/* At NexusAgents, we bridge the gap between busy lives and everyday necessities. As your trusted local service partner, we specialize in secure doorstep deliveries, personalized shopping assistance, and hassle-free errand management. Our network of vetted professionals combines tech-driven efficiency with human-centric care, handling everything from urgent document transfers to meticulous grocery runs. Beyond physical tasks, we empower businesses with administrative support and tech consultations, ensuring both homes and enterprises thrive. With transparent pricing, real-time tracking, and a commitment to reliability, we transform time-consuming chores into seamless experiences. NexusAgents isn’t just a service—it’s your extended team, redefining convenience in the modern world. */}
              We’re your hyperlocal solution hub, offering secure transfers, deliveries, personal shopping, and errand services for busy lives. With tech-driven agents and vetted pros, we simplify tasks from grocery runs to business paperwork. Trusted reliability, transparent pricing—we turn chores into effortless moments.
            </p>
          </div>
          <div>
            <h2 className="text-3xl font-bold text-white mb-6">Features</h2>
            <ul className="list-unstyled space-y-4 text-center" aria-label="Quick links">
              {/* <li><a href="refund" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Refund Policy</a></li> */}
              <li><a href="terms" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Terms of Service</a></li>
              <li><a href="privacy" className="text-sky-100 text-2xl no-underline hover:text-sky-300 transition-colors">Privacy Policy</a></li>
            </ul>
          </div>
          <div>
            <h2 className="text-3xl font-bold text-white mb-6">Ready to Experience Convenience?</h2>
            <p className="text-sky-100 mb-8 text-xl">Join hundreds of satisfied customers today!</p>
            <div className="flex justify-center space-x-4">
              {/* <a href='register' className="bg-white no-underline text-blue-900 px-8 py-3 rounded-full font-semibold hover:bg-sky-50 transition-colors">
                                Sign Up Now
                            </a> */}
              <a href='contact' className="border-2 border-white no-underline text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-colors">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-blue-900 text-sky-100 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p>Copyright © 2025 NexusAgents. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}